import AuthenticationModule from './modules/authentication';
import ApplicationModule from './modules/application';
import ApplicationsModule from './modules/applications';
import ShippingModule from './modules/shipping';
import teamMemberModule from './modules/team-member';
import walletModule from './modules/wallet';

const modules = {
  authentication: AuthenticationModule,
  application: ApplicationModule,
  applications: ApplicationsModule,
  shipping: ShippingModule,
  teamMember: teamMemberModule,
  wallet: walletModule,
};

export default modules;
